import {Skeleton, Button, Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { useEffect, useState } from "react";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import useGeolocation from "../../hooks/useGeolocation";

const ScanningActivityComponent = ({regions, scanningActivityData}) => {
    const navigate = useNavigate();
    const {isLoadingGetVerificationCount,isLoadingGetScanningActivity} = useGeolocation();

    const [hasNoVerificationCount, setHasNoVerificationCount] = useState(false)
    const [scanningActivityLogs, setScanningActivityLogs] = useState([])

    const [isFetchingScannedLogs, setFetchingScannedLogs] = useState(true);

    useEffect(() => {
        const isAllPercentZero = regions.every((item) => item.percent == 0)
        setHasNoVerificationCount(isAllPercentZero)
    }, [JSON.stringify(regions)])

    useEffect(() => {
        if (scanningActivityData) setScanningActivityLogs(scanningActivityData.content)
    }, [JSON.stringify(scanningActivityData)])

    useEffect(() => {
        setTimeout(() => {
            setFetchingScannedLogs(false);
        }, 3000)
    }, [])


    const renderCustomLabel = ({region, percent}) => {
        return percent > 0 ? `${region} - ${percent.toFixed(2)}%` : null;
    }

    const CustomTooltip = ({active, payload}) => {
        if (active && payload && payload?.length > 0) {
            return (
                <div style={{backgroundColor: "#fff", padding: "5px", border: "1px solid #ccc"}}>
                    <p style={{margin: 0}}>
                        <strong>{`${payload[0].payload.region}:`} </strong>{`${payload[0].value}%`}
                    </p>
                </div>
            )
        }

        return null;
    }
      

    return(
        <>
            <Box sx={{textAlign: "end", mb: 2}}>
                <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                    onClick={(e) => navigate("/reports/geolocation-verification")}
                >
                    Go to Reports
                </Button>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                    <Card variant="outlined">
                        <CardContent>
                            {
                                (isLoadingGetVerificationCount) ?
                                    <Skeleton variant="circular" width={500} height={500} sx={{backgroundColor: "#d8d8fdbd", margin: "auto"}} />
                                :
                                    (!isLoadingGetVerificationCount && hasNoVerificationCount ? 
                                        <Typography align="center">
                                            No available data to display.
                                        </Typography>
                                :
                                    <ResponsiveContainer width="100%" height={500}>
                                        <PieChart>
                                            <Pie
                                                dataKey="percent"
                                                isAnimationActive={false}
                                                data={regions}
                                                cx={"50%"}
                                                cy={"50%"}
                                                fill="#8884d8"
                                                label={renderCustomLabel}
                                                labelLine={true}
                                            >
                                                {regions.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                                ))}
                                            </Pie>
                                            <Tooltip content={<CustomTooltip />} />
                                        </PieChart>
                                    </ResponsiveContainer>
                                )
                            }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography variant="h6" align="center">Scanning Activity Logs</Typography>
                            <br />
                            {
                                (isFetchingScannedLogs) ?
                                    [0, 1, 2, 3, 4, 6, 7, 8].map((item) => (
                                        <Grid container spacing={2}>
                                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height="55px" />
                                            </Grid>

                                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height="55px" />
                                            </Grid>

                                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height="55px" />
                                            </Grid>
                                        </Grid>
                                    ))
                                :
                                    (!isLoadingGetScanningActivity && !isFetchingScannedLogs && scanningActivityLogs.length == 0) ? 
                                        <Typography align="center">
                                            No available data to display.
                                        </Typography>
                                :
                                    (!isLoadingGetScanningActivity && !isFetchingScannedLogs && scanningActivityLogs.map((item) => (
                                        <>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                    <Typography>{moment(item.timestamp).format("MMMM DD, YYYY h:mm:ss A")}</Typography>

                                                </Grid>
                                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                    <Typography>OVI: {item.ovi}</Typography>
                                                </Grid>
                                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                    <Typography color={(item.status === "Suspicious") ? "#fda501" : (item.status === "Successful") ? "#3fbf7e" : "#e67260"}>{item.status}</Typography>
                                                </Grid>
                                            </Grid>

                                            <hr />
                                        </>
                                    )))
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}

export default ScanningActivityComponent